// extracted by mini-css-extract-plugin
export default {"primaryText":"main_primaryText__cF3I7","secondaryText":"main_secondaryText__0xD-N","accentText":"main_accentText__T2Cl4","whiteText":"main_whiteText__hAPD9"};